import { useAppRouter } from '@/common/route/useAppRouter';
import { validateDate } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CHALLENGE } from '@/modules/challenge/router';
import { challengeService } from '@/services/challenge';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const router = useAppRouter();

    const model = reactive({
        name: null,
        toApp: null,
        amount: null,
        link: null,
        startTime: null,
        endTime: null,
        image: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        link: { required },
        amount: { required, numeric, minValue: minValue(1) },
        toApp: { required, numeric, minValue: minValue(1) },
        startTime: { required, validateDate: validateDate() },
        endTime: { required, validateDate: validateDate() }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            challengeService.create(
                model.name,
                model.toApp,
                model.amount,
                model.link,
                model.startTime.getTime(),
                model.endTime.getTime(),
                model.imageFile
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_CHALLENGE.INDEX })
    });

    return { v$, model, validations, create };
}
